<template>
        <div id='couponlist'>
              <NavTop title='优惠券列表' :islink='true' linkurl='/my'/>
              <div class='maincon'>
                  <div class="goodsitem" v-for="item in couponlist" :key="item.id">
                      <div class="goodsitem-row">
                        <div class="goodsitem-col1">
                            <div :class="item.isused?'couponcon-used':'couponcon-noused'">
                                 <div>
                                    <span class="coupon-rmb">¥</span><span class="coupon-words1">{{item.value}}</span>
                                 </div>
                                 <div>
                                    <span class="coupon-words2">满{{item.condition}}可用</span>
                                 </div> 
                            </div>
                        </div>
                        <div class="goodsitem-col2">
                            <div class="goodsitem-col2-line1">{{item.name}}</div>
                            <div class="goodsitem-col2-line2">{{item.desc}}</div>
                            <div class="goodsitem-col2-line2"></div>
                            <div class="goodsitem-col2-line3">
                                <div class="goodsprice"></div>
                                <div class="goodsnums">
                                    <div class="trainbtn bgred" v-if="!item.isused">
                                        <span>未使用</span> 
                                    </div>
                                    <div class="trainbtn bggrey" v-else>
                                       <span>已使用</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>  
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  name: 'couponlist',
  data(){
    return {
        couponlist:[]
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){
       this.$post("/coupon/getCouponList",{}).then((data)=>{
           if(data.result.success){
               this.couponlist=data.result.info.couponlist
           }else{
               this.$toast(data.result.info)
           }
       })
    }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#couponlist{background-color:#F6F6F6;min-height: 100vh;}
.maincon{display: flex;flex-flow: column nowrap;margin-bottom: 100px;padding: 0 0.25rem;}
.goodsitem{display: flex;background-color: #fff;margin-top: 0.25rem;height: 3.8rem;align-items:center;border:1px solid #e7e7e7;border-radius: 0.2rem;}
.goodsitem-row{display: flex;flex-flow: row nowrap;justify-content: flex-start;width:100%;height: 100%;}
.goodsitem-col1{flex:1.2;}
.couponcon-noused{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;background-color: #ee0a24;width:100%;height:100%;border-top-left-radius: 0.2rem;border-bottom-left-radius: 0.2rem;}
.couponcon-used{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;background-color: #9999;width:100%;height:100%;border-top-left-radius: 0.2rem;border-bottom-left-radius: 0.2rem;}

.goodsitem-col1 img{width:100%;}
.goodsitem-col2 {display: flex; flex-flow: column nowrap;text-align: left;width:100%;flex:3;padding:0.35rem 0.15rem 0 0.35rem;}
.goodsitem-col2-line1{font-size: 0.35rem;}
.goodsitem-col2-line2{font-size: 0.3rem;color:#5e5e5e;margin-top: 0.15rem;}
.goodsitem-col2-line3{margin-top: 0.1rem;display: flex;flex-flow: row nowrap;}
.goodsnums{margin-left: auto;margin-right:0.3rem;}
.goodsprice{color:#ff3600;font-size:0.4rem;display: flex;align-items: center;}
.bottomcon{display: flex;width:100%;background-color:#fff;height: 80px;position: fixed;left:0;bottom: 0;align-items: center;}
.bottomcon-left{display: flex;padding-left: 0.5rem;}
.goodswords{color:#333;font-size:0.35rem}
.bottomcon-right{margin-left: auto;padding-right: 0.3rem;}
.bottomcon-orderbtn{background-color:#ee0a24;color:#fff;height:1rem;width:3rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.bottomcon-orderbtn-words{font-size:0.35rem;}
.headimg{width:100%;height:100%;border-top-left-radius: 0.2rem;border-bottom-left-radius: 0.2rem;}
.trainbtn{border-radius: 0.12rem;width:2rem;color:#fff;display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;padding: 0.1rem;}
.bggrey{background-color: #999999;}
.bgred{background-color:#ee0a24;}
.coupon-rmb{font-size:0.30rem;color:#fff;}
.coupon-words1{font-size:0.45rem;color:#fff;}
.coupon-words2{font-size:0.30rem;color:#fff;}
</style>


